import React from 'react';
import { Calendar, Flag, Timer, Globe, MapPin, Award, Camera, Megaphone } from 'lucide-react';
import { Link } from 'react-router-dom';
export function About() {
  const services = [{
    title: 'Listing Services',
    description: 'Through our listing services, event management planners and organizers, race directors, and clubs can showcase their races, activities, or club details on RaceLookup.com to attract RaceLookup users and internet users looking and searching for these specific types of services and groups.',
    icon: Calendar
  }, {
    title: 'Event Production',
    description: 'We produce race events and activities for runners and walkers. We also provide event management, consulting, and equipment rental services to other nonprofits and businesses. Many of our services, like custom apparel, medals, trinkets, and marketing, are available across the United States.',
    icon: Flag
  }, {
    title: 'Race Timing',
    description: 'RaceLookup is a certified USATF race timing company specializing in all aspects of race organization, timing, and finish line services. We provide timing services in support of many different endurance sports like running, cycling, and multi-sport. We also offer course development, USATF certification, and course management services.',
    icon: Timer
  }, {
    title: 'Digital Services',
    description: 'RaceLookup also offers website design and hosting, registration design and processing, professional photography and videos, photo tagging, and photo and video hosting services.',
    icon: Globe
  }];
  return <div className="w-full bg-gray-50 min-h-screen" data-id="element-222">
      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-[#0E578E] to-[#01AAE7] py-20 sm:py-24 overflow-hidden" data-id="element-223">
        {/* Background Pattern */}
        <div className="absolute inset-0 opacity-10" data-id="element-224">
          <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-white rounded-full blur-3xl" data-id="element-225"></div>
          <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-white rounded-full blur-3xl" data-id="element-226"></div>
        </div>

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10 relative z-10 text-center" data-id="element-227">
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-black text-white mb-6 leading-tight" data-id="element-228">
            About Us
          </h1>
          <p className="text-lg sm:text-xl text-white/90 leading-relaxed max-w-2xl mx-auto" data-id="element-229">
            Your full-service partner for endurance events, from concept to
            finish line.
          </p>
        </div>
      </section>

      {/* Company Overview */}
      <section className="py-16 sm:py-20" data-id="element-230">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10" data-id="element-231">
          <div className="bg-white rounded-3xl shadow-xl border border-gray-100 overflow-hidden" data-id="element-232">
            <div className="grid lg:grid-cols-2 gap-0" data-id="element-233">
              <div className="p-8 sm:p-12 lg:p-16 flex flex-col justify-center" data-id="element-234">
                <div className="inline-flex items-center gap-2 px-4 py-2 bg-blue-50 text-[#01AAE7] rounded-full text-sm font-bold w-fit mb-6" data-id="element-235">
                  <MapPin className="h-4 w-4" data-id="element-236" />
                  Headquartered in Phoenix, AZ
                </div>
                <h2 className="text-3xl sm:text-4xl font-black text-gray-900 mb-6 leading-tight" data-id="element-237">
                  We are RaceLookup
                </h2>
                <p className="text-lg text-gray-600 leading-relaxed mb-6" data-id="element-238">
                  RaceLookup is an event management company headquartered out of
                  Phoenix, Arizona and is a full-service company able to help
                  with sporting events from initial event concept through to
                  completion or anywhere in between.
                </p>
                <p className="text-lg text-gray-600 leading-relaxed" data-id="element-239">
                  Whether you're organizing a local 5K or a major marathon, our
                  team brings expertise, passion, and professional execution to
                  every event we touch.
                </p>
              </div>
              <div className="relative h-64 lg:h-auto bg-gray-100" data-id="element-240">
                <img src="https://images.unsplash.com/photo-1532444458054-01a7dd3e9fca?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80" alt="Runners at the starting line" className="absolute inset-0 w-full h-full object-cover" data-id="element-241" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent lg:bg-gradient-to-l" data-id="element-242"></div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Services Grid */}
      <section className="py-16 sm:py-20 bg-white" data-id="element-243">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10" data-id="element-244">
          <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-245">
            <h2 className="text-3xl sm:text-4xl font-black text-gray-900 mb-4" data-id="element-246">
              Our Services
            </h2>
            <p className="text-lg text-gray-600" data-id="element-247">
              Comprehensive solutions for event directors, clubs, and athletes.
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-8 lg:gap-10" data-id="element-248">
            {services.map((service, index) => <div key={index} className="group p-8 rounded-2xl bg-gray-50 border border-gray-100 hover:border-[#01AAE7]/30 hover:shadow-xl hover:shadow-[#01AAE7]/5 transition-all duration-300" data-id="element-249">
                <div className="w-14 h-14 bg-white rounded-xl shadow-md flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300" data-id="element-250">
                  <service.icon className="h-7 w-7 text-[#01AAE7]" data-id="element-251" />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-4 group-hover:text-[#01AAE7] transition-colors" data-id="element-252">
                  {service.title}
                </h3>
                <p className="text-gray-600 leading-relaxed" data-id="element-253">
                  {service.description}
                </p>
              </div>)}
          </div>
        </div>
      </section>

      {/* Features / Highlights */}
      <section className="py-16 sm:py-20" data-id="element-254">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10" data-id="element-255">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6" data-id="element-256">
            {[{
            icon: Award,
            label: 'USATF Certified'
          }, {
            icon: Globe,
            label: 'Nationwide Service'
          }, {
            icon: Camera,
            label: 'Pro Media'
          }, {
            icon: Megaphone,
            label: 'Event Marketing'
          }].map((item, index) => <div key={index} className="flex flex-col items-center justify-center p-6 bg-white rounded-2xl shadow-sm border border-gray-100 text-center" data-id="element-257">
                <item.icon className="h-8 w-8 text-[#01AAE7] mb-3" data-id="element-258" />
                <span className="font-bold text-gray-900" data-id="element-259">{item.label}</span>
              </div>)}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gray-900 text-white overflow-hidden relative" data-id="element-260">
        <div className="absolute inset-0 opacity-20" data-id="element-261">
          <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-[#01AAE7] rounded-full blur-[100px] translate-x-1/2 -translate-y-1/2" data-id="element-262"></div>
        </div>

        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-10 text-center relative z-10" data-id="element-263">
          <h2 className="text-3xl sm:text-4xl font-black mb-6" data-id="element-264">
            Ready to elevate your event?
          </h2>
          <p className="text-xl text-gray-300 mb-10 max-w-2xl mx-auto" data-id="element-265">
            Whether you need full event production or specific services, we're
            here to help make your event a success.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-266">
            <Link to="/contact" className="px-8 py-4 bg-gradient-to-r from-[#01AAE7] to-[#0199d6] text-white font-bold rounded-xl hover:from-[#0199d6] hover:to-[#0188c5] transition-all shadow-lg hover:shadow-[#01AAE7]/25 transform hover:-translate-y-1" data-id="element-267">
              Contact Us
            </Link>
            <Link to="/services" className="px-8 py-4 bg-white/10 backdrop-blur-sm border border-white/20 text-white font-bold rounded-xl hover:bg-white/20 transition-all" data-id="element-268">
              View Services
            </Link>
          </div>
        </div>
      </section>
    </div>;
}